import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
// -- components --
import { CardType3Component } from 'app/modules/jc3/components/card-type-3/card-type-3.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-step-1',
    standalone: true,
    imports: [MatIconModule, CommonModule, CardType3Component, FormsModule],
    templateUrl: './step-1.component.html',
    styleUrl: './step-1.component.scss',
})
export class Step1Component {
    @Input() products: any[] = [];
    @Input() data: any = {};

    searchText: string = '';
    resultCountText: string = '';
    resultCountTextBM: string = '';
    filteredProductsData: any[] = [];
    visibleCount: number = 5;
    increment: number = 5;
    isMobile = window.innerWidth < 768;
    dataFound: boolean = true;
    gaPrefix = 'financing_&_protection_';

    ngOnInit() {
        this.filteredProductsData = this.productsData; // show all initially
        if (this.isMobile) {
            this.visibleCount = 5;
        } else {
            this.visibleCount = 25;
        }

        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 768;

            if (this.isMobile) {
                this.visibleCount = 5;
            } else {
                this.visibleCount = 25;
            }
        });
    }

    get productsData() {
        const groups: any = {};

        const sortedProducts = [...(this.products || [])].sort((a, b) => {
            const nameA = (a?.institution || '').toLowerCase();
            const nameB = (b?.institution || '').toLowerCase();
            return nameA.localeCompare(nameB);
        });

        sortedProducts.forEach((card) => {
            let categoryLabel = '';

            if (card?.category?.toLowerCase() === 'finance') {
                categoryLabel = 'Green Financing';
            } else if (card?.category?.toLowerCase() === 'insurance') {
                categoryLabel = 'ESG-related Insurance';
            }

            if (!groups[categoryLabel]) {
                groups[categoryLabel] = [];
            }

            groups[categoryLabel].push({
                image:
                    card?.imagedesktop ||
                    card?.logo_url ||
                    card?.mediaFileStores?.at(0)?.s3url,
                url: card?.url,
                buttonText: card?.CTA,
                title: card?.institution || card?.title || 'Title',
                description: card?.description || 'Description',
            });
        });

        return [
            {
                category: 'Green Financing',
                items: groups['Green Financing'] || [],
            },
            {
                category: 'ESG-related Insurance',
                items: groups['ESG-related Insurance'] || [],
            },
        ];
    }

    onSearch(): void {
        const text = this.searchText?.trim().toLowerCase() || '';

        if (!text) {
            this.filteredProductsData = this.productsData; // reset
            this.resultCountText = '';
            this.resultCountTextBM = '';
            return;
        }

        this.filteredProductsData = this.productsData
            .map((group) => {
                // match inside items
                const matchingItems = group.items.filter(
                    (item) =>
                        (item.title || '').toLowerCase().includes(text) ||
                        (item.description || '').toLowerCase().includes(text)
                );

                // match category label
                const categoryMatches = group.category
                    .toLowerCase()
                    .includes(text);

                if (categoryMatches || matchingItems.length > 0) {
                    return {
                        ...group,
                        items: categoryMatches ? group.items : matchingItems,
                    };
                }
                return null;
            })
            .filter(Boolean);

        const count = this.filteredProductsData.reduce(
            (acc: number, group: any) => acc + (group.items?.length || 0),
            0
        );

        this.dataFound = count > 0;

        this.resultCountText =
            count === 0
                ? 'No results found'
                : `${count} result${count > 1 ? 's' : ''} found`;

        this.resultCountTextBM =
            count === 0 ? 'Tiada hasil ditemui' : `${count} hasil dijumpai`;
    }

    openLink(url: string) {
        if (url) {
            window.open(url, '_blank');
        }
    }

    showMore() {
        this.visibleCount += this.increment;
    }

    makeGroupSlug(str: string) {
        return (
            this.gaPrefix + str?.toLowerCase()?.replaceAll(' ', '_') + '_apply_'
        );
    }
}
